module.exports = __webpack_public_path__ + "img/inative.5af788af.svg";